var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlotoAnchorLink',{attrs:{"aria-label":_vm.$t('allocate')},on:{"click":_vm.triggerAction}},[_c('span',{staticClass:"ml-1 action-menu-text"},[_vm._v(" "+_vm._s(_vm.$t('allocate'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }